import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';
import { SettingsService, SettingsStorage } from '@next/core-lib/settings';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map, takeUntil } from 'rxjs/operators';

import { SettingsKeys, settingsContextName } from '../shared/models/shared.models';
import { BexOverviewComponent } from './components/bex-overview/bex-overview.component';
import { BexTotalsComponent } from './components/bex-totals/bex-totals.component';

@Component({
  selector: 'app-bex',
  templateUrl: './bex.component.html',
  imports: [BexOverviewComponent, BexTotalsComponent, AsyncPipe, TranslatePipe],
})
export class BexComponent implements OnInit, OnDestroy {
  public showTotals$: Observable<boolean>;
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly settingsService: SettingsService) {}

  ngOnInit(): void {
    this.showTotals$ = this.settingsService
      .getSettingsUpdates({
        contextName: settingsContextName,
        storage: SettingsStorage.PlatformSession,
        key: SettingsKeys.totals,
      })
      .pipe(
        debounceTime(0),
        map((settings) =>
          settings?.map((setting) => (Array.isArray(setting) ? setting[0] : setting)),
        ),
        map((settings) => settings?.[0]?.data as boolean),
        takeUntil(this.destroy$),
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
